import(/* webpackMode: "eager", webpackExports: ["Background"] */ "/vercel/path0/frontend/src/app/components/Background/index.tsx");
